import { Card, CardContent, CircularProgress, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {},
}));


function CentralPaperServiceShop({ className, items, Loading, handleOpenDetail }) {
  const classes = useStyles();
  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            {Loading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              :
              <List className={classes.root}>
                {items.map(Data =>
                  <div>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar key={Data.FIS_NO}>
                        <Typography
                          component="span"
                          variant="h3"
                          className={classes.inline}
                          color="textPrimary">{Data.GUN}</Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{Data.AY}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{Data.YIL}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="caption"
                          className={classes.inline}
                          color="textPrimary">{Data.SAAT}
                        </Typography>
                        <br />
                      </ListItemAvatar>
                      <ListItemText
                        primary={Data.FIS_NO + ' ' + Data.ADI + ' ' + Data.SOYADI}
                        secondary={
                          <React.Fragment>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                            </Typography>
                            <Typography
                              component="span"
                              variant="body2"
                              color="textPrimary"
                            >
                              {Data.DURUM}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.SERVIS_KODU} {Data.SERVIS}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.BASVURU_NEDENI}
                            </Typography>
                            <Typography
                              component="span"
                              variant="body2"
                              color="textPrimary"
                            >
                              {Data.KUL_MODEL_KODU} {Data.MODEL}
                            </Typography>
                            <Typography
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Data.TEL1} {Data.TEL2}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Detayları Göster">
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenDetail(Data)}
                            edge="end"
                            size="small">
                            <ArrowForwardIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </div>
                )}
              </List>
            }
          </div>
        </CardContent>
      </Card>
    </div >
  );
}

CentralPaperServiceShop.propTypes = {
  className: PropTypes.string
};

export default CentralPaperServiceShop;
